import app from './config/configApp';
import router from './routes/protectedRoute';
import store from '@/vuex/store';
import i18n from './i18n';
import './static/css/style.css';
// Vue 3rd party plugins
import '@/core/plugins/ant-design';
import '@/core/plugins/fonts';
import '@/core/plugins/unicons';
import '@/core/components/custom';

app.config.productionTip = false;
app.use(store);
app.use(router);
app.use(i18n);
app.mount('#app');